import { useEnvironment } from '@wix/yoshi-flow-editor';
import { getEditorHost } from '../selectors/isModernPagesPanelEditor';

const STUDIO_2_HOST = 'STUDIO2';

export const isStudio2EditorCanvas = ({
  isEditor,
  editorHost = getEditorHost(),
}: {
  isEditor: boolean;
  editorHost?: string;
}): boolean => isEditor && editorHost === STUDIO_2_HOST;

export const useStudio2EditorCanvas = (): boolean => {
  const { isEditor } = useEnvironment();

  return isStudio2EditorCanvas({ isEditor });
};
